import { render } from "./PendingNetworks.vue?vue&type=template&id=4d0bee0e"
import script from "./PendingNetworks.vue?vue&type=script&lang=js"
export * from "./PendingNetworks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__